/* ==================================================================
 * Lyoria Upsell — AJAX Add-to-Cart Handler
 *
 * - Hört auf submit der .lyoria-upsell__form Forms
 * - POST /cart/add.js mit Variant-ID + qty=1
 * - Refreshed Cart-Drawer + Cart-Sections via Shopify Section Rendering
 * - Zeigt Button-State (Loading -> Success)
 *
 * Defensiv: greift nur wenn das Theme cart-drawer ODER cart-page
 * als Section nutzt. Funktioniert auch ohne Drawer (z.B. nur Cart-Page).
 * ================================================================== */
(function () {
  'use strict';

  const LOG_PREFIX = '[lyoria-upsell]';

  function log(...args) {
    if (window.Shopify && window.Shopify.designMode) {
      console.log(LOG_PREFIX, ...args);
    }
  }

  function getSectionsToRefresh() {
    // Sammle alle bekannten Cart-Sections, die aktualisiert werden sollen.
    const sections = new Set();
    document.querySelectorAll('cart-drawer, cart-items, cart-drawer-items').forEach((el) => {
      const sectionId = el.dataset.sectionId || el.id;
      if (sectionId) sections.add(sectionId);
    });
    return Array.from(sections);
  }

  function setButtonState(button, state) {
    if (!button) return;
    const textEl = button.querySelector('.lyoria-upsell__btn-text');
    button.dataset.state = state;
    switch (state) {
      case 'loading':
        button.disabled = true;
        if (textEl) textEl.textContent = button.dataset.loadingLabel || 'Wird hinzugefügt…';
        break;
      case 'success':
        button.disabled = true;
        if (textEl) textEl.textContent = button.dataset.successLabel || 'Hinzugefügt ✓';
        setTimeout(() => {
          button.disabled = false;
          button.dataset.state = '';
          if (textEl) textEl.textContent = button.dataset.addLabel || 'Hinzufügen';
        }, 2200);
        break;
      case 'error':
        button.disabled = false;
        if (textEl) textEl.textContent = 'Fehler — nochmal?';
        setTimeout(() => {
          button.dataset.state = '';
          if (textEl) textEl.textContent = button.dataset.addLabel || 'Hinzufügen';
        }, 3000);
        break;
      default:
        button.disabled = false;
        if (textEl) textEl.textContent = button.dataset.addLabel || 'Hinzufügen';
    }
  }

  async function addToCart(variantId, sectionsToRefresh) {
    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };

    if (sectionsToRefresh.length > 0) {
      body.sections = sectionsToRefresh;
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errBody = await response.text();
      throw new Error(`Cart add failed (${response.status}): ${errBody}`);
    }

    return response.json();
  }

  function refreshCartSections(parsedSections) {
    if (!parsedSections) return;
    Object.entries(parsedSections).forEach(([sectionId, html]) => {
      // 1. cart-drawer-Element
      const drawerEl = document.querySelector(`cart-drawer[data-section-id="${sectionId}"]`);
      if (drawerEl) {
        drawerEl.innerHTML = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(`cart-drawer[data-section-id="${sectionId}"]`)?.innerHTML || drawerEl.innerHTML;
      }
      // 2. cart-items-Element (Drawer + Cart Page)
      const itemsEl = document.querySelector(`cart-items[data-section-id="${sectionId}"]`);
      if (itemsEl) {
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = newDoc.querySelector(`cart-items[data-section-id="${sectionId}"]`);
        if (newItems) {
          itemsEl.innerHTML = newItems.innerHTML;
        }
      }
    });
  }

  function openCartDrawer() {
    // Innova-Theme nutzt häufig cart-drawer.open() oder data-attribute toggles.
    // Wir versuchen beide gängige Patterns defensiv.
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (drawer.classList) {
      drawer.classList.add('is-open', 'open', 'active');
      document.body.classList.add('drawer-open', 'overflow-hidden');
    }
  }

  function updateCartCountBubble(itemCount) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count').forEach((el) => {
      el.textContent = String(itemCount);
      if (itemCount > 0) {
        el.classList.remove('hidden', 'is-hidden');
        el.removeAttribute('hidden');
      }
    });
  }

  function handleSubmit(event) {
    const form = event.target.closest('.lyoria-upsell__form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('.lyoria-upsell__btn');
    const select = form.querySelector('select[name="id"]');
    const hiddenInput = form.querySelector('input[name="id"]');
    const variantId = (select && select.value) || (hiddenInput && hiddenInput.value);

    if (!variantId) {
      log('No variant ID');
      setButtonState(button, 'error');
      return;
    }

    setButtonState(button, 'loading');
    const sectionsToRefresh = getSectionsToRefresh();

    addToCart(variantId, sectionsToRefresh)
      .then((response) => {
        log('Added', response);
        setButtonState(button, 'success');

        if (response.sections) {
          refreshCartSections(response.sections);
        }

        if (typeof response.item_count === 'number') {
          updateCartCountBubble(response.item_count);
        }

        // Drawer öffnen — außer wir sind schon auf der Cart-Page oder im Drawer
        const wrapper = form.closest('[data-lyoria-upsell]');
        const context = wrapper ? wrapper.dataset.context : '';
        if (context !== 'cart-page' && context !== 'drawer') {
          openCartDrawer();
        }

        // Eigenes Event für Theme-Listener
        document.dispatchEvent(new CustomEvent('lyoria-upsell:added', { detail: response }));
      })
      .catch((err) => {
        log('Error', err);
        setButtonState(button, 'error');
      });
  }

  function init() {
    document.addEventListener('submit', handleSubmit);
    log('init');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
